// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import Dialog from 'presentations/views/components/atoms/Dialog';
import Button from 'presentations/views/components/atoms/Button';

import { spacing } from 'presentations/views/styles';
import EventLocationTypeListItem from './components/EventLocationTypeListItem';
import { LocationType } from 'domains/models/event_type/locationType';
import { gray01 } from 'presentations/views/styles/color';

type Props = {
  isOpen: boolean;
  locations: {
    id: LocationType;
    name: string;
    text: string | null;
  }[];
  onClickClose: () => void;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  return (
    <Dialog
      isOpen={props.isOpen}
      title={t('title')}
      scroll
      isFillWidth
      width={400}
      actions={
        <StyledButtonContainer>
          <StyledButton
            color="inherit"
            size="large"
            onClick={props.onClickClose}
          >
            {t('close')}
          </StyledButton>
        </StyledButtonContainer>
      }
    >
      {props.locations.map((e) => (
        <StyledListItem key={`location_type_${e}`}>
          <EventLocationTypeListItem
            locationType={e.id}
            name={e.text || e.name}
          />
        </StyledListItem>
      ))}
    </Dialog>
  );
}

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing(16)};
`;
const StyledButton = styled(Button)`
  width: 100%;
  max-width: 160px;
  color: ${gray01};
`;
const StyledListItem = styled.div`
  &:not(:first-child) {
    margin-top: ${spacing(20)};
  }
`;
